/**
 * A content request was refused with `team_member_disabled`: the caller's seat
 * in `workspaceKey` is disabled. The app shell listens, re-reads the contexts
 * and shows the disabled-workspace notice instead of the page, so pages keep
 * the session and the selected workspace and never sign the user out over it.
 * `workspaceKey` is the `X-Active-Context` the refused request sent; `null`
 * when it sent none and the server used its default.
 */
export interface MemberAccessRefreshDetail {
  workspaceKey: string | null
}

type MemberAccessRefreshListener = (detail: MemberAccessRefreshDetail) => void
const listeners = new Set<MemberAccessRefreshListener>()

export function emitMemberAccessRefresh(workspaceKey: string | null): void {
  const detail = { workspaceKey }
  for (const listener of listeners) listener(detail)
}

export function subscribeMemberAccessRefresh(listener: MemberAccessRefreshListener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
